// extracted by mini-css-extract-plugin
module.exports = {"note_slider":"Archives_note_slider__3ZyQh"};